/**
 * Resets the scroll position on every route navigation, back/forward included.
 * The flows are wizard-like, so restoring a previous scroll offset is more
 * confusing than helpful.
 */
export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter();

  // Fires once the new page component has resolved.
  nuxtApp.hook("page:finish", () => {
    scrollToTop();
  });

  // Covers navigations that reuse the same page component (param/query only),
  // where `page:finish` does not fire again.
  router.afterEach((to, from) => {
    const isSameLocation = to.fullPath === from.fullPath;
    const isHashOnly = to.path === from.path && to.hash !== from.hash;

    if (isSameLocation || isHashOnly) {
      return;
    }
    scrollToTop();
  });
});
